import React from "react";
import Button from "@mui/material/Button";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { withTranslation } from "react-i18next";

import axios from "../../components/Axios";

// Billing > Data Storage and Access: the storage subscription
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      hours: 0,
      monthly: 0,
      due_time: 0,
      subscribed: false,
      sub: {},
    };
  }

  componentDidMount() {
    this.getItems();
  }

  async getItems() {
    let resp = await axios.get("/user/stripe/subscriptions");
    this.setState({ loading: false, hours: resp.data.total_duration / 3600 });

    if (resp.data.data.length > 0) {
      this.setState({
        subscribed: true,
        sub: resp.data.data[0],
        monthly: resp.data.upcoming.amount_due / 100,
        due_time: resp.data.upcoming.next_payment_attempt,
      });
    } else {
      this.setState({ subscribed: false, sub: {}, monthly: 0, due_time: 0 });
    }
  }

  cancelSubscription = async () => {
    this.setState({ loading: true });
    await axios.delete("/user/stripe/subscription");
    await this.getItems();
    if (this.props.onChange) this.props.onChange();
  };

  createSub = async () => {
    this.setState({ loading: true });
    await axios.post("/user/stripe/subscription", {});
    await this.getItems();
    if (this.props.onChange) this.props.onChange();
  };

  formatDate(u) {
    let d = new Date(u);
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  render() {
    const { t } = this.props;
    const { loading, subscribed } = this.state;

    return (
      <section className="ac-card" aria-labelledby="ac-subscription-h">
        <div className="ac-head">
          <h2 id="ac-subscription-h" className="ac-title">
            {t("Data Storage and Access")}
          </h2>
          {subscribed && (
            <span className="ac-badge">
              <CheckCircleIcon />
              {t("Active")}
            </span>
          )}
        </div>
        <div className="ac-body" style={{ gap: "10px" }}>
          <p className="ac-desc">{t("Provides data storage and searchable access for video AI analysis results")}</p>
          <div className="ac-stats">
            <div className="ac-stat">
              <span className="ac-overline">{t("Video hours")}</span>
              <b>{loading ? "-" : this.state.hours.toFixed(1)}</b>
            </div>
            {subscribed && (
              <>
                <div className="ac-stat">
                  <span className="ac-overline">{t("Monthly")}</span>
                  <b>{this.state.monthly.toFixed(2)} USD</b>
                </div>
                <div className="ac-stat">
                  <span className="ac-overline">{t("Next invoice")}</span>
                  <b>{this.formatDate(this.state.due_time * 1000)}</b>
                </div>
              </>
            )}
          </div>
          <p className="ac-help ac-mono">
            10 USD/{t("month")} · +0.50 USD/mo {t("per hours over")} 20 {t("hours")}
          </p>
        </div>
        <div className="ac-foot">
          {subscribed ? (
            <Button className="Button ac-btn" onClick={this.cancelSubscription} disabled={loading}>
              {t("Cancel Subscription")}
            </Button>
          ) : (
            <Button className="Button ButtonPrimary ac-btn" onClick={this.createSub} disabled={loading}>
              {t("Subscribe")}
            </Button>
          )}
        </div>
      </section>
    );
  }
}

export default withTranslation()(Index);
